export const MAIL_TEMPLATE = `{
  subject
  data
  id
  createdAt
  updatedAt
}`
